export default __webpack_public_path__ + "static/media/icn-padlock-unlocked.4e2f0f21.svg";